module.exports = __webpack_public_path__ + "static/img/no_access_img.a3c7ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/no_access_img.png
// module id = o5LA
// module chunks = 150